module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/bd0654a64acea4ed0382b083f524b353.png";